import { useTranslation } from 'react-i18next';
import Badge from './Badge.jsx';

/** Compact lead score readout: 0-100 bar plus the HOT/WARM/COLD pill. */
const ScoreGauge = ({ score = 0, temperature = 'COLD', compact = false }) => {
  const { t } = useTranslation();

  return (
    <div className={compact ? 'score score--compact' : 'score'}>
      <div className="score__head">
        <span className="score__value">{score}</span>
        <span className="score__max">/ 100</span>
        <Badge value={temperature} label={t(`leads.temperatures.${temperature}`)} />
      </div>
      <div className="score__bar" role="img" aria-label={`${score}/100`}>
        <span className={`score__fill score__fill--${temperature.toLowerCase()}`} style={{ width: `${score}%` }} />
      </div>
    </div>
  );
};

export default ScoreGauge;
